import { useEpochStatus } from '../../hooks/useEpochStatus.ts';
import { useI18n } from '../../i18n/index.tsx';
import { CatchUp } from '../tx/CatchUp.tsx';

/**
 * Shown on every page once two or more finished epochs are unpaid (one is normal for the minutes after a boundary,
 * before the keeper's rebase lands): what is waiting, and the button that pays it.
 */
export function EpochBanner() {
  const { t } = useI18n();
  const { behind } = useEpochStatus();
  if (behind < 2) return null;
  return (
    <div className="notice warn epoch-banner" role="status" data-testid="epoch-banner">
      <div>
        <b>{t('epoch.behindTitle', { n: behind })}</b>
        <div className="epoch-body">{t('epoch.behindBody')}</div>
      </div>
      <CatchUp />
    </div>
  );
}
